import React from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Typography,
    CircularProgress,
    Alert
} from '@mui/material';
import { useQuery } from 'react-query';
import { HttpService } from 'core/services/http';
import { Utils } from 'core/utils';

const formatText = (value, fallback = '') => {
    if (!Utils.normalizeText) return value ?? fallback;
    return Utils.normalizeText(value, fallback);
};

function SelectCategory({ value, onChange, label = "Category", fullWidth = true, size = "small", ...props }) {
    const { data, isLoading, isError } = useQuery('categories', async () => {
        const service = new HttpService();
        const data = await service.get('/job/category/', null);
        return Array.isArray(data) ? data : (data?.results || []);
    });

    const categories = React.useMemo(() => {
        const cats = data?.results || [];
        return Array.isArray(cats) ? cats : (Array.isArray(data) ? data : []);
    }, [data]);

    if (isError) {
        return (
            <Alert severity="error" size="small">
                Failed to load categories
            </Alert>
        );
    }

    return (
        <FormControl fullWidth={fullWidth} size={size} {...props}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={value || ''}
                label={label}
                onChange={(e) => onChange && onChange(e.target.value)}
                disabled={isLoading}
            >
                <MenuItem value="">
                    <Typography variant="body2" color="text.secondary">
                        All Categories
                    </Typography>
                </MenuItem>
                {isLoading ? (
                    <MenuItem disabled>
                        <Box display="flex" alignItems="center" gap={1}>
                            <CircularProgress size={16} />
                            <Typography variant="body2">Loading...</Typography>
                        </Box>
                    </MenuItem>
                ) : (
                    categories.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                            <Box display="flex" alignItems="center" gap={1.5}>
                                {category.image && (
                                    <Box
                                        component="img"
                                        src={category.image}
                                        alt={formatText(category.title)}
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            objectFit: 'cover',
                                            borderRadius: 0.5,
                                            border: '1px solid',
                                            borderColor: 'divider'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                )}
                                <Typography variant="body2">
                                    {formatText(category.title)}
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))
                )}
            </Select>
        </FormControl>
    );
}

export default SelectCategory;

